/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  StartBotOptions,
  StartBotStatus200,
  StartBotStatus404,
  StartBotStatus500,
} from '../types/StartBot'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { startBot } from '../clients/startBot'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const startBotMutationKey = () => [{ url: '/v1/bots/:bot_id/start' }] as const

export function startBotMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = startBotMutationKey()
  return mutationOptions<
    StartBotStatus200,
    ResponseErrorConfig<StartBotStatus404 | StartBotStatus500>,
    StartBotOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path }) => {
      return startBot({ ...config, path, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Start a bot
 * {@link /v1/bots/:bot_id/start}
 */
export function useStartBot<TContext>(
  options: {
    mutation?: UseMutationOptions<
      StartBotStatus200,
      ResponseErrorConfig<StartBotStatus404 | StartBotStatus500>,
      StartBotOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? startBotMutationKey()

  const baseOptions = startBotMutationOptions(config) as UseMutationOptions<
    StartBotStatus200,
    ResponseErrorConfig<StartBotStatus404 | StartBotStatus500>,
    StartBotOptions,
    TContext
  >

  return useMutation<
    StartBotStatus200,
    ResponseErrorConfig<StartBotStatus404 | StartBotStatus500>,
    StartBotOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    StartBotStatus200,
    ResponseErrorConfig<StartBotStatus404 | StartBotStatus500>,
    StartBotOptions,
    TContext
  >
}
